export default __webpack_public_path__ + "static/media/tutorial-body.bc5d7b9e.png";